import { TASK_KIND_LABEL, WORKFLOW_STATE_LABEL } from '../../../core/constants/domain';

export const STATE_FILTERS = [
    { value: '', label: 'Todas' },
    { value: 'ready', label: WORKFLOW_STATE_LABEL.ready },
    { value: 'claimed', label: WORKFLOW_STATE_LABEL.claimed },
    { value: 'in_review', label: WORKFLOW_STATE_LABEL.in_review },
    { value: 'returned', label: WORKFLOW_STATE_LABEL.returned },
    { value: 'blocked', label: WORKFLOW_STATE_LABEL.blocked },
    { value: 'proposed', label: WORKFLOW_STATE_LABEL.proposed },
    { value: 'done', label: WORKFLOW_STATE_LABEL.done },
];

export const KIND_FILTERS = [
    { value: '', label: 'Todo tipo' },
    ...Object.entries(TASK_KIND_LABEL).map(([value, label]) => ({ value, label })),
];

export function readFilters(params) {
    const project = Number(params.get('project'));
    return {
        state: params.get('state') || '',
        kind: params.get('kind') || '',
        projectId: Number.isFinite(project) && project > 0 ? project : null,
    };
}

export function hasActiveFilters(filters) {
    return !!(filters.state || filters.kind || filters.projectId);
}
